import React, { useState } from 'react';
import axios from 'axios';
import '../../Styles/login/emailverify.css'; // Import the CSS file
import { useBranding } from '../../config/branding';
import { useNavigate } from 'react-router-dom';

const EmailVerify = () => {
  const branding = useBranding();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSendResetLink = async () => {
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setError('');
    setMessage('');

    try {
      const response = await axios.post(process.env.REACT_APP_PASSWORD_RESET_URL, { email });
      setMessage(response.data.message || 'Reset link sent successfully!');
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred while sending the reset link.');
    }
  };

  return (
    <div className="forgot-verify-page">
      <div className="forgot-verify-left">
        <img
          src={branding.LOGIN_WALLPAPER}
          alt="Campus"
          className="forgot-verify-wallpaper"
        />
        <div className="forgot-verify-overlay" />
        <div className="forgot-verify-copy">
          <span className="forgot-verify-chip">Account Recovery</span>
          <h1>{branding.APP_TITLE || 'Proctored Assessment'}</h1>
          <p>{branding.ORG_NAME}</p>
        </div>
      </div>

      <div className="forgot-verify-right">
        <div className="forgot-verify-card">
          <img
            src={branding.LOGIN_LOGO}
            alt={branding.LOGO_ALT_TEXT || 'Organization Logo'}
            className="forgot-verify-logo"
          />

          <h2 className="forgot-verify-title">Forgot Password?</h2>
          <p className="forgot-verify-subtitle">
            Enter your registered email and we will send a reset link.
          </p>

          <div className="forgot-verify-input-group">
            <label htmlFor="email" className="forgot-verify-label">Registered Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@domain.com"
              className="forgot-verify-input"
            />
          </div>

          {error && <div className="forgot-verify-error">{error}</div>}
          {message && <div className="forgot-verify-message">{message}</div>}

          <button onClick={handleSendResetLink} className="forgot-verify-button">
            Send Reset Link
          </button>

          <button
            type="button"
            className="forgot-verify-back"
            onClick={() => navigate('/')}
          >
            Back To Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerify;